import React, { useState } from 'react'
import AlertaConfirmacion from './AlertaConfirmacion';

import BotonSuccess from './Botones/BotonSuccess';
import BotonDanger from './Botones/BotonDanger';
import BotonInfo from './Botones/BotonInfo';

//Si hay más de un buttonConfirm en una misma línea es recomendable usarlos dentro de un div como el siguiente:
{/* <div className="d-flex justify-content-between pt-3"> */}

/**
 * 
 * @param {*} onClickConfirmar Función que se ejecutará cuando se confirme la acción, también pondrá el estado de confirmación en false.
 * @param {*} textoBotonPrincipal Texto que tendrá el botón principal, que luego requiere de una confirmación.
 * @param {*} onClickCancelar Función opcional que se ejecutará cuando se cancele la confirmación de la acción, por defecto pone el estado de confirmación en falso.
 * @param {*} estadoEdicionInicial Estado inicial en el que se encuentra la confirmación, por defecto viene en false, una vez que se oprima el botón principal se cambia al estado de confirmación en true.
 * @param {*} textoAlerta Texto que tendrá la alerta de confirmación una vez que se oprima el botón principal.
 * @param {*} onClick Función opcional que se ejecutará una vez que se oprima el botón principal, por defecto pone el estado de confirmación en true.
 * @param {*} children Es lo que irá adentro del botón, también puede ir texto.
 *  
 * @returns 
 */
const ButtonConfirm = ({ children, onClick, onClickCancelar, onClickConfirmar, textoBotonPrincipal, textoAlerta, color = "success", textoBotonConfirmar = "Confirmar", ancho = "100%", estadoEdicionInicial = false, classNameAlert, classNameButton, size="sm", ...rest } ) => {

    const [estadoEdicion, setEstadoEdicion] = useState(estadoEdicionInicial);

    const activarBoton = () => { 
        if(!onClick){
            setEstadoEdicion(true);
            return;
        }
        if(onClick()) { 
            setEstadoEdicion(true);
        }
    };

    const getBoton = (color, classNameButton) => {
        switch(color) {
            case "success": return <BotonSuccess onClick={activarBoton} ancho={ancho} className={classNameButton}>{textoBotonPrincipal}{children}</BotonSuccess>
            case "danger": return <BotonDanger onClick={activarBoton} ancho={ancho} className={classNameButton}>{textoBotonPrincipal}{children}</BotonDanger>
            case "info": return <BotonInfo onClick={activarBoton} ancho={ancho} className={classNameButton}>{textoBotonPrincipal}{children}</BotonInfo>
        }
    };

    return (
        <>
            {
                estadoEdicion
                ?
                    <AlertaConfirmacion
                        onClickConfirmar={() => { onClickConfirmar(); setEstadoEdicion(false); }}
                        onClickCancelar={() =>{ if(onClickCancelar) onClickCancelar(); setEstadoEdicion(false); }}
                        textoAlerta={textoAlerta}
                        textoBotonConfirmar={textoBotonConfirmar}
                        color={color}
                        ancho = {ancho}
                        className={classNameAlert}
                        {...rest}
                    />
                :
                    getBoton(color, classNameButton)
            }
        </>
    )
}

export default ButtonConfirm